export default "__VITE_ASSET__Df99GoC5__"